(function () {
  'use strict';

  // Thumbnail image swap
  var thumbnails = document.querySelectorAll('.tff-product-main__thumbnail');
  var mainImage = document.getElementById('tff-main-image');

  thumbnails.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImage && mainImage.tagName === 'IMG') {
        mainImage.src = thumb.dataset.src;
        mainImage.alt = thumb.dataset.alt || '';
      }
      thumbnails.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  // Singles / pair toggle
  var formatBtns = document.querySelectorAll('.tff-format-btn');
  var priceDisplay = document.getElementById('tff-price-display');
  var variantInput = document.getElementById('tff-variant-id');

  formatBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      formatBtns.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');

      if (priceDisplay) {
        priceDisplay.textContent = btn.dataset.price;
      }
      if (variantInput) {
        variantInput.value = btn.dataset.variantId;
      }
    });
  });
})();
